import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DwDesignerSelectedItemState, DwDesignerStateService, DwUiPanelWidgetBaseComponent } from '@devwareapps/devware-cap';
import {
  QuestionFormLayoutState,
  QuestionFormLayoutWidgetRegistrationService
} from '../../services/question-form-layout-widget-registration.service';

import { QUESTION_FORM_LAYOUT_VARIANTS, QuestionFormLayoutVariant } from '../../models/question-form-layout.model';

/**
 * Gear-panel view for the Question Bank layout switch. All state and the
 * Devware plumbing live in QuestionFormLayoutWidgetRegistrationService,
 * because the panel destroys and recreates this component while the form
 * rebuilds after a preview. The stylesheet (features/question-editor.scss)
 * keys off the `qb-*` classes carried by the redesign variant.
 */
@Component({
  selector: 'app-question-form-layout-widget',
  templateUrl: './form-layout-widget.component.html',
  styleUrls: ['./form-layout-widget.component.scss']
})
export class QuestionFormLayoutWidgetComponent extends DwUiPanelWidgetBaseComponent {
  readonly title: string = 'Question Bank layout';
  readonly variants = QUESTION_FORM_LAYOUT_VARIANTS;
  readonly state: QuestionFormLayoutState;

  constructor(
    fb: FormBuilder,
    dwDesignerStateService: DwDesignerStateService,
    private readonly layoutService: QuestionFormLayoutWidgetRegistrationService
  ) {
    super(fb, dwDesignerStateService);
    this.state = layoutService.state;
  }

  trackByKey(_: number, variant: QuestionFormLayoutVariant): string {
    return variant.key;
  }

  apply(variant: QuestionFormLayoutVariant, persist: boolean): void {
    this.layoutService.apply(variant, persist);
  }

  // The widget has no preference form of its own; the base class requires these.
  protected createForm(fb: FormBuilder): FormGroup {
    return fb.group({});
  }

  startConfigureSection(_state: DwDesignerSelectedItemState<any>): void { }
}
